import API from 'services/API/index';

export default function getLkIp() {
  return API.request({
    method: 'GET',
    url: `/lkip/token`,
  });
}
